import ApplicationState from "@insite/client-framework/Store/ApplicationState";

// XC custom website selector helper

export function getIsCanadaWebsite(state: ApplicationState) {
    return state.context.website.name === "Buchanan Rubber" || state.context.website.name === "Amiflex";
}